import React from "react";
import { Link, useLocation, useParams, matchPath } from "react-router-dom";
import routeMeta from "../../routes/Routes";
import routeConfig from "../../routes/Config";

function normalizePath(pathname) {
    if (pathname === "/") return "/";
    return pathname.endsWith("/") ? pathname : pathname + "/";
}

function HeaderActions() {
    const location = useLocation();
    const params = useParams();

    const activeRoute = routeConfig.find(route => matchPath({ path: route.path, end: false }, location.pathname));
    const meta = activeRoute ? activeRoute.meta : (routeMeta["/"] || {});
    const actions = meta?.headerActions || {};
    const { showDateRange = false, filters = [], buttons = [] } = actions;

    if (!showDateRange && filters.length === 0 && buttons.length === 0) {
        return null;
    }

    return (
        <div className="page-header-right-items">
            <div className="d-flex d-md-none">
                <a
                    href="#"
                    className="page-header-right-close-toggle"
                >
                    <i className="feather-arrow-left me-2"></i>
                    <span>Back</span>
                </a>
            </div>

            <div className="d-flex align-items-center gap-2 page-header-right-items-wrapper">
                {showDateRange && (
                    <div
                        id="reportrange"
                        className="reportrange-picker d-flex align-items-center"
                    >
                        <span className="reportrange-picker-field"></span>
                    </div>
                )}

                {filters.length > 0 && (
                    <div className="dropdown filter-dropdown">
                        <a
                            className="btn btn-md btn-light-brand"
                            data-bs-toggle="dropdown"
                            data-bs-offset="0, 10"
                            data-bs-auto-close="outside"
                        >
                            <i className="feather-filter me-2"></i>
                            <span>Filter</span>
                        </a>
                        <div className="dropdown-menu dropdown-menu-end">
                            {filters.map((filter) => (
                                <div key={filter.id} className="dropdown-item">
                                    <div className="custom-control custom-checkbox">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id={filter.id}
                                            defaultChecked={filter.defaultChecked}
                                        />
                                        <label
                                            className="custom-control-label c-pointer"
                                            htmlFor={filter.id}
                                        >
                                            {filter.label}
                                        </label>
                                    </div>
                                </div>
                            ))}
                            <div className="dropdown-divider"></div>
                        </div>
                    </div>
                )}

                {buttons.map((btn, index) => {
                    let to = btn.to;
                    if (typeof to === "function") {
                        to = to({ params, location });
                    }

                    if (btn.type === "link") {
                        return (
                            <Link
                                key={index}
                                to={to}
                                className={`btn btn-md btn-${btn.variant || "primary"}`}
                            >
                                {btn.icon && <i className={`${btn.icon} me-2`} />}
                                <span>{btn.label}</span>
                            </Link>
                        );
                    }

                    if (btn.type === "button") {
                        return (
                            <button
                                key={index}
                                type="button"
                                className={`btn btn-md btn-${btn.variant || "primary"}`}
                                onClick={btn.onClick}
                            >
                                {btn.icon && <i className={`${btn.icon} me-2`} />}
                                <span>{btn.label}</span>
                            </button>
                        );
                    }

                    return null;
                })}
            </div>
        </div>
    );
}

export default HeaderActions;
